import { jsx as d } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import l from "../../utils/classNames.js";
const e = f((s, n) => {
  const { className: o, buttonAlignment: t, useBodyPaddings: a = !1, children: i, ...r } = s, c = l(
    "ApplicationLayoutBodyBottomBar",
    t === "left" && "justify-content-start",
    t === "right" && "justify-content-end",
    t !== "left" && t !== "right" && "justify-content-between",
    a && "use-body-padding",
    o && o
  );
  return /* @__PURE__ */ d("div", { ref: n, ...r, className: c, children: i });
});
e.LEFT = "left";
e.RIGHT = "right";
export {
  e as default
};
//# sourceMappingURL=ApplicationLayoutBodyBottomBar.js.map
